import React from 'react'
import styled from 'styled-components'
import ModalWindow from '../ModalWindow'
import ContentWrapper from '../../shared/ContentWrapper'
import StructuredTable from '../../shared/StructuredTable'

const RowRadius = styled.div`
  .ReactTable .rt-tbody .rt-tr-group {
    border-radius: 5px;
  }
`

const TextWrap = styled.span`
  white-space: normal;
`

const RuleInfoDialog = ({ ruleData, visible, handleClose, t }) => {
  const priorities = [
    '',
    t('priority_high'),
    t('priority_medium'),
    t('priority_low'),
  ]
  const categories = [t('data_quality'), t('data_availability')]

  const TableColumns = t => [
    {
      Header: t('partner_name'),
      accessor: 'partnerName',
      Cell: row => {
        return <TextWrap>{row.original.partnerName}</TextWrap>
      },
      maxWidth: 120,
    },
    {
      Header: t('name'),
      accessor: 'name',
      Cell: row => {
        return (
          <TextWrap>
            {row.original.partnerRuleName}
            {row.original.partnerRuleName == row.original.name
              ? ''
              : '(' + row.original.name + ')'}
          </TextWrap>
        )
      },
      maxWidth: 250,
    },
    {
      Header: t('recommendation'),
      accessor: 'recommendation',
      Cell: row => {
        return <TextWrap>{row.original.recommendation}</TextWrap>
      },
    },
    {
      Header: t('category'),
      accessor: 'groupName',
      Cell: row => {
        return <TextWrap>{row.original.groupName}</TextWrap>
      },
      maxWidth: 120,
    },
    {
      Header: t('priority'),
      accessor: 'priority',
      Cell: row => {
        return <TextWrap>{priorities[row.original.priority]}</TextWrap>
      },
      maxWidth: 100,
    },
  ]

  return (
    <ModalWindow
      minWidth={'40%'}
      setWidth={'70%'}
      onCancel={handleClose}
      title={t('Feed Audit Rule Information')}
      visible={visible}
      cancelText={t('close')}
    >
      <ContentWrapper>
        <RowRadius>
          <StructuredTable
            columns={TableColumns(t)}
            data={ruleData}
            rowPadding
            t={t}
            pageSize={ruleData.length}
            noPagination
          />
        </RowRadius>
      </ContentWrapper>
    </ModalWindow>
  )
}

export default RuleInfoDialog
